import NativeClient from "@/client/native-client";
import {
  FridgeDetailsSettingsList, 
  FridgeDetailsFunctionList, 
  FridgeDetailsSetSettingsList,
  FRIDGE_DETAILS_FUNCTION_ID,
  FRIDGE_DETAILS_COOLING_MODE,
  FRIDGE_DETAILS_COOLING_MODE_DISPLAY_STRING
} from "@/types/fridgeDetails"
import store from "@/store";

/** Y軸目盛りの生成  */
export const createYAxisScales = (maxValue: number) => {
  let retValue: Array<number> = [];
  if (0 <= maxValue && maxValue <= 6) {
    retValue = [0, 2, 4, 6, 8, 10, 12];
  } else if (7 <= maxValue && maxValue <= 30) {
    retValue = [0, 5, 10, 15, 20, 25, 30];
  } else if (31 <= maxValue && maxValue <= 60) {
    retValue = [0, 10, 20, 30, 40, 50, 60];
  } else if (61 <= maxValue && maxValue <= 120) {
    retValue = [0, 20, 40, 60, 80, 100,120];
  } else if (121 <= maxValue && maxValue <= 300) {
    retValue = [0, 50, 100, 150, 200, 250, 300];
  } else {
    retValue = [0, 100, 200, 300, 400, 500, 600];
  }
  return retValue;
};

/** 秒の数字の0埋め */
export const secondsZeroPadding = (seconds: number | null) => {
  if (seconds == null) {
    return "00";
  }
  return `${('00' + seconds ).slice(-2)}`;
};

/** quench, cold, frozenの日本語文字列変換 */
export const transleteCoolingModeToDisplayString = (coolingMode: string) => {
  let retValue = "";
  switch (coolingMode) {
    case FRIDGE_DETAILS_COOLING_MODE.QUENCH:
      retValue = FRIDGE_DETAILS_COOLING_MODE_DISPLAY_STRING.QUENCH;
      break;
    case FRIDGE_DETAILS_COOLING_MODE.COLD:
      retValue = FRIDGE_DETAILS_COOLING_MODE_DISPLAY_STRING.COLD;
      break;
    case FRIDGE_DETAILS_COOLING_MODE.FROZEN:
      retValue = FRIDGE_DETAILS_COOLING_MODE_DISPLAY_STRING.FROZEN;
      break;
    default:
      break;
  }
  return retValue;
};

/** 運転状態取得APIのレスポンスを、機器制御実行APIのリクエスト・ボディに変換する */
export const translateFridgeDetailsSettingsToBuffer = (settingList: FridgeDetailsSettingsList, functionList: FridgeDetailsFunctionList) => {
  const result = new FridgeDetailsSetSettingsList();

  // 全機種共通のものだけコピーする
  result.cold_room_mode = settingList.cold_room_mode;
  result.freezing_room_mode = settingList.freezing_room_mode;
  result.fast_ice_status = settingList.fast_ice_status;
  result.stop_ice_status = settingList.stop_ice_status;
  result.door_alarms_mode = settingList.door_alarms_mode;
  result.coldroom_light_mode = settingList.coldroom_light_mode;

  // functionListによる機種別の設定
  for (const item of functionList.reizo_function_list) {
    switch (item.function_id) {
      case FRIDGE_DETAILS_FUNCTION_ID.COOLOVEN:
        if (item.function_value) {
          result.cooloven_lamp_mode = settingList.cooloven_lamp_mode;
          result.cooloven_mode = settingList.cooloven_mode;
          result.cooloven_time = settingList.cooloven_time;
          result.cooloven_second = settingList.cooloven_second;
        } else {
          result.cooloven_lamp_mode = undefined;
          result.cooloven_mode = undefined;
          result.cooloven_time = undefined;
          result.cooloven_second = undefined;
        }
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.RECIPE:
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.DOOROPENINFO:
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.HOUSESITTING:
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.INITREQUIRED:
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.QUICKBUTTON:
        if (item.function_value) {
          result.quick_button_setting_list = [];
          for (const item of settingList.quick_button_setting_list) {
            const bufferItem = { mode: item.mode, name: item.name, time: item.time, time_second: item.time_second }
            result.quick_button_setting_list.push(bufferItem);
          }
        } else {
          result.quick_button_setting_list = undefined;
        }
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.FIRMWAREUPDATE:
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.PARTIALFREEZINGROOM:
        if (item.function_value) {
          result.partial_mode = undefined;
          result.partial_freezing_room_mode = settingList.partial_freezing_room_mode;
        } else {
          result.partial_mode = settingList.partial_mode;
          result.partial_freezing_room_mode = undefined;
        }
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.ECONAVILEDONOFF:
        if (item.function_value) {
          result.econavi_lamp_status = settingList.econavi_lamp_status;
        } else {
          result.econavi_lamp_status = undefined;
        }
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.PCROOMLIGHTMODE:
        if (item.function_value) {
          result.pcroom_light_mode = settingList.pcroom_light_mode;
        } else {
          result.pcroom_light_mode = undefined;
        }
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.FRESHFROZEN:
        if (item.function_value) {
          result.fresh_frozen_status = settingList.fresh_frozen_status;
        } else {
          result.fresh_frozen_status = undefined;
        }
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.FASTGOOD:
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.OUTAGEPREPARE:
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.AICOOLING:
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.PARTIALHALFDEFROST:
        if (item.function_value) {
          result.partial_half_defrost_mode = settingList.partial_half_defrost_mode
        } else {
          result.partial_half_defrost_mode = undefined
        }
        break;
      case FRIDGE_DETAILS_FUNCTION_ID.SCROOMTEMPARATURE:
        if (item.function_value) {
          result.sc_room_temperature = settingList.sc_room_temperature
        } else {
          result.sc_room_temperature = undefined
        }
        break;
      default:
        break;
    }
  }
  return result;
};

/** 冷蔵庫の機能有無 */
export const isValidFridgeDetailsFunction = (id: string) => {
  const functionList: FridgeDetailsFunctionList | null = store.getters["fridgeDetails/getFunctionList"];
  if (functionList == null) {
    return false;
  }
  const findIndex = functionList.reizo_function_list.findIndex(item => item.function_id == id);
  if (findIndex == -1) {
    return false;
  }
  return functionList.reizo_function_list[findIndex].function_value;
};

/** ページIDへの変換 */
export const translateContententTypeToPageID = (contentType: string) => {
  const pageId = "RF-" + contentType;
  NativeClient.sendDebugLog("translateContententTypeToPageID contentType = " + contentType + ", pageId = " + pageId);
  return pageId;
};